import api from './client';

export const inventoryApi = {
  list:      (params?: any) => api.get('/inventory', { params }),
  movements: (productId: number) => api.get(`/inventory/movements/${productId}`),
};
